import React from 'react';
import {
  Avatar,
  createTheme,
  Box,
  Card,
  Button,
  TextField,
  MenuItem,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import Client from '../Client';
import {
  locationsList,
  salesByCombo,
  salesByProduct
} from './simpleBiReportsApi';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

let theme = createTheme();

Date.prototype.getISODay = function () {
  return (this.getDay() + 6) % 7 + 1;
};

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function addDays(date, days) {
  if (date) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    result = format(result, 'yyyy-MM-dd');
    return result;
  }
}

function isValidDateValue(value) {
  return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);
}

function getSafeDateRange(dateFrom, dateTo) {
  const safeDateFrom = isValidDateValue(dateFrom) ? dateFrom : today;
  const maxDateTo = addDays(safeDateFrom, 50);
  let safeDateTo = isValidDateValue(dateTo) ? dateTo : safeDateFrom;

  if (safeDateTo < safeDateFrom) {
    safeDateTo = safeDateFrom;
  }

  if (maxDateTo && safeDateTo > maxDateTo) {
    safeDateTo = maxDateTo;
  }

  return {
    dateFrom: safeDateFrom,
    dateTo: safeDateTo
  };
}

let d = new Date();
let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date().setDate(new Date().getDate() - 1), 'yyyy-MM-dd');
let d1Month = format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd');
let d1Week = format(new Date().setDate(new Date().getDate() - new Date().getISODay() + 1), 'yyyy-MM-dd');

const period = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'custom', label: 'Custom' }
];

const objectToCsv = function (data) {
  const csvRows = [];

  if (!data || !data.length) {
    return "No data";
  }

  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${String(val).replace(/"/g, '""')}"`;
    });

    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class ProductChartGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      salesproduct_list: { result: [] },
      page: 0,
      rowsPerPage: -1,

      periodValue: "today",
      customDateVisible: false,

      dateFrom: today,
      dateTo: today,

      location: 0,
      locationName: { name: "All Locations" },

      delivery: 2,
      salesType: 'products',

      locations: [],
      deliverys: [
        { iref: 2, name: "All" },
        { iref: 0, name: "Restaurant" },
        { iref: 1, name: "Delivery" },
        { iref: 3, name: "App Clients" }
      ],

      filterData: {},
      productSearch: ''
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);
    this.selectSalesType = this.selectSalesType.bind(this);
    this.handleProductSearch = this.handleProductSearch.bind(this);

    this.queryData = {};
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const safeDateRange = getSafeDateRange(this.state.dateFrom, this.state.dateTo);
    const salesType = this.state.salesType || 'products';

    const queryData = {
      location: this.state.location,
      delivery: this.state.delivery,
      dateFrom: safeDateRange.dateFrom,
      dateTo: safeDateRange.dateTo
    };

    const data = salesType === 'combos'
      ? salesByCombo(this.state.client, queryData)
      : salesByProduct(this.state.client, queryData);

    if (!data || !Array.isArray(data?.result)) {
      console.error("Product sales API unavailable", {
        endpoint: salesType === 'combos' ? "salesByCombo" : "salesByProduct",
        payload: queryData,
        response: data
      });

      this.setState({
        salesproduct_list: { result: [] },
        filterData: { ...queryData, salesType },
        dateFrom: safeDateRange.dateFrom,
        dateTo: safeDateRange.dateTo,
        page: 0
      });

      return;
    }

    this.setState({
      salesproduct_list: data,
      filterData: { ...queryData, salesType },
      dateFrom: safeDateRange.dateFrom,
      dateTo: safeDateRange.dateTo
    });

    const locResp = locationsList(this.state.client);

    if (locResp && Array.isArray(locResp.locations)) {
      this.setState({ locations: locResp.locations });
    } else if (Array.isArray(locResp)) {
      this.setState({ locations: locResp });
    }
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  addDateFrom = (event) => {
    const value = event.target.value;
    const safeDate = isValidDateValue(value) ? value : today;

    this.setState({
      dateFrom: safeDate,
      dateTo: safeDate
    });
  }

  addDateTo = (event) => {
    const value = event.target.value;
    const safeDate = isValidDateValue(value) ? value : this.state.dateFrom;

    this.setState({ dateTo: safeDate });
  }

  handleProductSearch = (event) => {
    this.setState({
      productSearch: event.target.value,
      page: 0
    });
  }

  selectPeriod = (event) => {
    const value = event.target.value;

    switch (value) {
      case "today":
        this.setState(
          {
            periodValue: value,
            customDateVisible: false,
            dateFrom: today,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "yesterday":
        this.setState(
          {
            periodValue: value,
            customDateVisible: false,
            dateFrom: yesterday,
            dateTo: yesterday
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "week":
        this.setState(
          {
            periodValue: value,
            customDateVisible: false,
            dateFrom: d1Week,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "month":
        this.setState(
          {
            periodValue: value,
            customDateVisible: false,
            dateFrom: d1Month,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "custom":
        this.setState({
          periodValue: value,
          customDateVisible: true
        });
        break;

      default:
        this.setState({
          periodValue: "today",
          customDateVisible: false,
          dateFrom: today,
          dateTo: today
        }, function () {
          this.doSync();
        });
        break;
    }
  }

  selectLocation = (event) => {
    const value = event.target.value;

    const locationObj = this.state.locations.find(
      (o) => String(o.iref) === String(value)
    );

    this.setState(
      {
        location: value,
        locationName: locationObj || { name: "All Locations" }
      },
      function () {
        this.doSync();
      }
    );
  }

  selectDelivery = (event) => {
    this.setState(
      { delivery: Number(event.target.value) },
      function () {
        this.doSync();
      }
    );
  }

  selectSalesType = (event, value) => {
    if (!value) {
      return;
    }

    this.setState(
      {
        salesType: value,
        productSearch: '',
        page: 0
      },
      function () {
        this.doSync();
      }
    );
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0
    });
  }

  onDownload = () => {
    const rows = this.state.salesproduct_list?.result || [];
    const locName = this.state.locationName?.name || "All Locations";
    const safeDateFrom = isValidDateValue(this.state.dateFrom) ? this.state.dateFrom : today;
    const safeDateTo = isValidDateValue(this.state.dateTo) ? this.state.dateTo : safeDateFrom;
    const reportLabel = this.state.salesType === 'combos' ? 'Combo Sales' : 'Product Sales';
    const filePrefix = this.state.salesType === 'combos' ? 'comboSales' : 'productSales';
    const deliveryName = this.state.deliverys.find(
      (option) => option.iref === this.state.delivery
    )?.name || 'All';

    const csvHeader = `${reportLabel}
Date From: ${safeDateFrom}
Date To: ${safeDateTo}
Location: ${locName}
Delivery: ${deliveryName}`;

    const csvBody = rows.length ? objectToCsv(rows) : "No data";
    const csv = "\uFEFF" + csvHeader + "\n" + csvBody;

    const link = document.createElement("a");
    link.download = `${filePrefix}_${locName}_${safeDateFrom}_${safeDateTo}.csv`;
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  render() {
    let locations = [{ iref: 0, name: "All Locations" }];

    if (this.state.locations) {
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];

        if (fData && fData.iref !== undefined) {
          let myData = { iref: fData.iref, name: fData.name };
          locations.push(myData);
        }
      });
    }

    let deliverys = [
      { iref: 2, name: "All" },
      { iref: 0, name: "Restaurant" },
      { iref: 1, name: "Delivery" },
      { iref: 3, name: "App Clients" }
    ];

    let productSalesList = [];

    if (this.state.salesproduct_list && this.state.salesproduct_list.result) {
      let counter = 0;

      Object.keys(this.state.salesproduct_list.result).forEach(key => {
        let fData = this.state.salesproduct_list.result[key];

        let p = {
          id: counter + 1,
          name: fData.name,
          quantity: thousandsSeparator(fData.quantity || 0),
          value: thousandsSeparator(parseInt(fData.value || 0))
        };

        counter += 1;
        productSalesList.push(p);
      });
    }

    const filteredProductSalesList = productSalesList.filter((product) =>
      product.name
        .toLowerCase()
        .includes(this.state.productSearch.toLowerCase())
    );

    const pagedProductSalesList = this.state.rowsPerPage > 0
      ? filteredProductSalesList.slice(
        this.state.page * this.state.rowsPerPage,
        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
      )
      : filteredProductSalesList;

    const isComboSales = this.state.salesType === "combos";

    return (
      <Card
        sx={{
          borderRadius: "14px",
          overflow: "hidden",
          height: {
            xs: "calc(100vh - 92px)",
            md: "calc(100vh - 104px)"
          },
          minHeight: {
            xs: 500,
            sm: 540
          },
          display: "flex",
          flexDirection: "column"
        }}
      >
        {/* Filters */}
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 1.35fr 0.95fr",
              sm: "115px 165px 105px 150px auto",
              md: "115px 180px 110px 160px auto"
            },
            gap: {
              xs: 1,
              sm: 1.25
            },
            alignItems: "end",
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <TextField
            id="standard-select-period"
            select
            value={this.state.periodValue}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.selectPeriod}
          >
            {period.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            id="standard-select-location"
            select
            value={this.state.location}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.selectLocation}
          >
            {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            id="standard-select-delivery"
            select
            value={this.state.delivery}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.selectDelivery}
          >
            {deliverys.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>

          <Box
            sx={{
              gridColumn: {
                xs: "1 / -1",
                sm: "auto"
              },
              display: "flex",
              justifyContent: {
                xs: "stretch",
                sm: "flex-start"
              },
              alignItems: "center"
            }}
          >
            <ToggleButtonGroup
              exclusive
              size="small"
              value={this.state.salesType}
              onChange={this.selectSalesType}
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto"
                },
                borderRadius: "12px",
                overflow: "hidden",
                "& .MuiToggleButton-root": {
                  flex: {
                    xs: 1,
                    sm: "unset"
                  },
                  px: {
                    xs: 1,
                    sm: 1.5
                  },
                  py: 0.45,
                  minHeight: 32,
                  fontSize: {
                    xs: "12.5px",
                    sm: "13px"
                  },
                  fontWeight: 600,
                  textTransform: "none",
                  borderColor: "rgba(0,0,0,0.12)"
                },
                "& .Mui-selected": {
                  backgroundColor: "#f6f4ef",
                  color: "#222"
                },
                "& .Mui-selected:hover": {
                  backgroundColor: "#eee9de"
                }
              }}
            >
              <ToggleButton value="products">
                Products
              </ToggleButton>

              <ToggleButton value="combos">
                Combos
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Button
            color="inherit"
            size="small"
            onClick={this.onDownload}
            variant="contained"
            sx={{
              maxWidth: '38px',
              minWidth: '38px',
              maxHeight: '38px',
              minHeight: '38px',
              display: {
                xs: 'none',
                sm: 'none',
                md: 'inline-flex'
              },
              justifySelf: "end"
            }}
          >
            <Avatar sx={{ width: 25, height: 25, bgcolor: theme.palette.success.light }}>
              <FileDownloadIcon fontSize="small" />
            </Avatar>
          </Button>

          {this.state.customDateVisible && (
            <Box
              sx={{
                gridColumn: "1 / -1",
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr 1fr 40px",
                  sm: "135px 135px 40px"
                },
                gap: 1,
                alignItems: "end"
              }}
            >
              <TextField
                size="small"
                id="date-from"
                label="From"
                type="date"
                value={isValidDateValue(this.state.dateFrom) ? this.state.dateFrom : today}
                variant="standard"
                sx={this.filterSx()}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: "#5b5b5b" }
                }}
                InputProps={{
                  sx: { color: "#5b5b5b" }
                }}
                inputProps={{
                  min: "2020-01-01",
                  style: {
                    color: "#5b5b5b",
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateFrom}
              />

              <TextField
                size="small"
                id="date-to"
                label="To"
                type="date"
                value={isValidDateValue(this.state.dateTo) ? this.state.dateTo : today}
                variant="standard"
                sx={this.filterSx()}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: "#5b5b5b" }
                }}
                InputProps={{
                  sx: { color: "#5b5b5b" }
                }}
                inputProps={{
                  min: "2020-01-01",
                  max: addDays(this.state.dateFrom, 50),
                  style: {
                    color: "#5b5b5b",
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateTo}
              />

              <Button
                color="inherit"
                onClick={() => this.doSync()}
                sx={{
                  maxWidth: '38px',
                  minWidth: '38px',
                  maxHeight: '38px',
                  minHeight: '38px'
                }}
              >
                <Avatar sx={{ width: 25, height: 25, bgcolor: theme.palette.primary.light }}>
                  <AutorenewIcon fontSize="small" />
                </Avatar>
              </Button>
            </Box>
          )}
        </Box>

        {/* Search */}
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <TextField
            size="small"
            label={isComboSales ? "Search combo" : "Search product"}
            variant="outlined"
            value={this.state.productSearch}
            onChange={this.handleProductSearch}
            fullWidth
            sx={{
              "& .MuiInputBase-input": {
                fontSize: {
                  xs: "16px",
                  sm: "14px"
                }
              },
              "& .MuiInputLabel-root": {
                fontSize: {
                  xs: "13px",
                  sm: "13px"
                }
              }
            }}
            InputProps={{
              endAdornment: this.state.productSearch && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => this.setState({ productSearch: '', page: 0 })}
                    edge="end"
                    size="small"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>

        {/* Table */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}
        >
          <TableContainer
            sx={{
              height: "100%",
              overflow: "auto"
            }}
          >
            <Table stickyHeader aria-label="product sales table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx("left")}>
                    <b>{isComboSales ? "Combo" : "Product"}</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right")}>
                    <b>Quantity</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right")}>
                    <b>Value</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {pagedProductSalesList.map((product) => {
                  return (
                    <TableRow
                      hover
                      key={product.id}
                      tabIndex={-1}
                    >
                      <TableCell sx={this.bodyCellSx("left", false)}>
                        {product.name}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("right")}>
                        {product.quantity}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("right", false)}>
                        {product.value}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={filteredProductSalesList.length}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={{
            borderTop: "1px solid rgba(0,0,0,0.08)",
            ".MuiTablePagination-toolbar": {
              minHeight: {
                xs: 46,
                sm: 52
              },
              px: {
                xs: 1,
                sm: 2
              }
            },
            ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
              fontSize: {
                xs: "13px",
                sm: "13px"
              }
            },
            ".MuiTablePagination-actions button": {
              padding: {
                xs: "4px",
                sm: "8px"
              }
            }
          }}
        />
      </Card>
    );
  }

  filterSx() {
    return {
      width: "100%",
      minWidth: 0,
      "& .MuiInputBase-input": {
        fontSize: {
          xs: "16px",
          sm: "14px"
        }
      },
      "& .MuiInputLabel-root": {
        fontSize: {
          xs: "13px",
          sm: "13px"
        }
      }
    };
  }

  headerCellSx(align) {
    return {
      padding: {
        xs: "8px 7px",
        sm: "7px"
      },
      textAlign: align,
      whiteSpace: "nowrap",
      fontSize: {
        xs: "13px",
        sm: "13px",
        md: "14px"
      },
      backgroundColor: "#f6f4ef"
    };
  }

  bodyCellSx(align, strong = false) {
    return {
      padding: {
        xs: "8px 7px",
        sm: "7px"
      },
      textAlign: align,
      whiteSpace: align === "left" ? "normal" : "nowrap",
      fontSize: {
        xs: "13.5px",
        sm: "13px",
        md: "14px"
      },
      fontWeight: strong ? 600 : 400,
      lineHeight: 1.35
    };
  }
}

export default ProductChartGroup;
